import React, { useMemo } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FIELD_PADDING } from '../SettlePayment/const';

const CompanyNameAutocomplete = ({ profile, value, onChange }) => {
	const { t } = useTranslation();

	// Only keep active contracts
	const contractList = useMemo(() => {
		return (profile?.agency_contracts || []).filter((c) => c?.active !== false);
	}, [profile]);

	// Find the default object by id, else null
	const getDefaultValue = () => {
		return contractList.find((c) => c._id === value) || null;
	};

	const filterOptions = createFilterOptions({
		matchFrom: 'start',
		stringify: (option) => option.company?.name || '',
	});

	return (
		<Autocomplete
			value={getDefaultValue()}
			options={contractList}
			getOptionLabel={(opt) => opt?.company?.name || ''}
			isOptionEqualToValue={(opt, val) => opt?.company?._id === val?.company?._id}
			filterOptions={filterOptions}
			onChange={(e, val) => onChange(val ? val._id : null)}
			clearOnEscape
			size="small"
			sx={FIELD_PADDING}
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder={t('FindByCompanyName')}
					variant="outlined"
					fullWidth
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{value ? (
									<InputAdornment position="end">
										<IconButton onClick={() => onChange?.(null)} disableRipple size="small">
											<CloseIcon />
										</IconButton>
									</InputAdornment>
								) : (
									params.InputProps.endAdornment
								)}
							</>
						),
					}}
				/>
			)}
		/>
	);
};

export default CompanyNameAutocomplete;